import { getSupabase } from '@/lib/supabase';
import type { SessionIndexEntry, UserId } from '@/schemas';
import { decodeRowToSessionIndex, type SessionIndexRow } from '../codec';

interface FetchSessionIndexOptions {
  updatedAfter?: number;
}

export async function fetchSessionIndex(
  userId: UserId,
  options: FetchSessionIndexOptions = {},
): Promise<SessionIndexEntry[]> {
  const client = getSupabase();
  let query = client
    .from('session_index')
    .select<'*', SessionIndexRow>('*')
    .eq('user_id', String(userId))
    .order('updated_at', { ascending: true });

  if (options.updatedAfter !== undefined) {
    query = query.gt('updated_at', options.updatedAfter);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return (data ?? []).map((row) => decodeRowToSessionIndex(row));
}
